import { DependencyList, useEffect } from "react";

export function useEffectAsync(func: () => Promise<void>, deps?: DependencyList): void {
    return useEffect(() => {
        async function innerFunc() {
            await func()
        }
        innerFunc()
    }, deps)
}